// extracted by mini-css-extract-plugin
export default {"actionBtn":"actionBtn-_1_IZ","nextBtn":"nextBtn-aI8WQ","backBtn":"backBtn-V_8gc"};